import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../../constants/common'
import {
  createDocFlowMappingResultPdfUrl,
  loadDocFlowMappingResultSourcePdf,
  revokeDocFlowMappingResultPdfUrl,
} from '../../../DocFlowMapping.utils'

export function useDocFlowMappingRecipientModalPreview({
  activeFileBytes,
  pagesRange,
}) {
  const [sourcePdf, setSourcePdf] = useState(null)
  const [hasSourceError, setSourceError] = useState(false)
  const [preview, setPreview] = useState(EMPTY_OBJECT)

  useEffect(() => {
    loadDocFlowMappingResultSourcePdf(activeFileBytes)
      .then(setSourcePdf)
      .catch(() => {
        setSourceError(true)
      })
  }, [activeFileBytes])

  useEffect(() => {
    if (sourcePdf) {
      const generation = { isCancelled: false }

      createDocFlowMappingResultPdfUrl({ pagesRange, sourcePdf })
        .then(url => {
          if (generation.isCancelled) {
            revokeDocFlowMappingResultPdfUrl(url)
          } else {
            setPreview({ pagesRange, url })
          }
        })
        .catch(() => {
          if (!generation.isCancelled) {
            setPreview({ pagesRange, url: null })
          }
        })

      return () => {
        generation.isCancelled = true
      }
    }
  }, [pagesRange, sourcePdf])

  useEffect(() => {
    return () => {
      revokeDocFlowMappingResultPdfUrl(preview.url)
    }
  }, [preview])

  // A preview belongs to the pages it was made for: the next document shows neither the previous file nor its error
  const isActivePreview = preview.pagesRange === pagesRange

  return {
    hasPreviewError: hasSourceError || (isActivePreview && !preview.url),
    previewFile:
      isActivePreview && preview.url ? { localUrl: preview.url } : null,
  }
}
